import axios from 'axios';
import {backendHost} from '../../../../store/config';

const postUpdateStatus = (params) => {
    return axios.post(`${backendHost}/api/admin/fs-game/update`, params);
};

export {
    postUpdateStatus
}